import { render, staticRenderFns } from "./AreaDialog.vue?vue&type=template&id=e5bcc4e0&scoped=true"
import script from "./AreaDialog.vue?vue&type=script&lang=js"
export * from "./AreaDialog.vue?vue&type=script&lang=js"
import style0 from "./AreaDialog.vue?vue&type=style&index=0&id=e5bcc4e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5bcc4e0",
  null
  
)

export default component.exports